import { FloorplanData } from '../types/FloorplanData';
import { MarkerData } from '../types/MarkerData';
import { API_DRAFT_TOURS } from '../utils/urls';
import { axios, post } from './baseAxios';

type CreateFloorplanRequest = {
  tour: { id: number };
  floorplan: FloorplanData;
};

type CreateFloorplansRequest = {
  tour: { id: number };
  floorplans: FloorplanData;
};

const url = API_DRAFT_TOURS;
export const updateDraftFloorplans = (tourId: number, request: CreateFloorplansRequest) =>
  post(`${url}/${tourId}/floorplans`, request);

export const createDraftFloorplan = (tourId: number, request: CreateFloorplanRequest) =>
  post(`${url}/${tourId}/floorplan`, request);

export const deleteDraftFloorplan = (tourId: number, floorPlanId: number) =>
  axios.delete(`${url}/${tourId}/floorplan/${floorPlanId}`);

export const updateDraftFloorplanMarker = (
  tourId: number,
  floorPlanId: number,
  request: MarkerData
) => axios.put(`${url}/${tourId}/floorplan/${floorPlanId}/marker/${request.code}`, request);
